import React from "react";
import "@/App.css";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Results from "@/components/Results";
import WhyUs from "@/components/WhyUs";
import Reviews from "@/components/Reviews";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Services />
      <Results />
      <WhyUs />
      <Reviews />
      <QuoteForm />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
